import { render } from "./pageLoader.vue?vue&type=template&id=64fd213e"
import script from "./pageLoader.vue?vue&type=script&lang=js"
export * from "./pageLoader.vue?vue&type=script&lang=js"

import "./pageLoader.vue?vue&type=style&index=0&id=64fd213e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__